import { render, staticRenderFns } from "./Component-VideoMonitorGrow.vue?vue&type=template&id=6aef8424"
import script from "./Component-VideoMonitorGrow.vue?vue&type=script&lang=js"
export * from "./Component-VideoMonitorGrow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports